var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"preloader-view text-center"},[_c('div',{staticStyle:{"width":"100px","margin":"0 auto","position":"fixed","bottom":"20px","right":"20px"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_c('app-logo')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }